<template>
  <div class="wrapper">
    <div class="breadcrumb">{{$t("news.list[0].breadcrumb")}}</div>
    <div class="container common" @mouseenter="on_top_enter" @mouseleave="on_top_leave">
      <swiper :options="swiperOptionThumbs" class="gallery-thumbs" ref="swiperThumbs">
        <swiper-slide v-for="item in newList" :key="item.id">{{item.publishTime.substring(0,10).replace(/-/g,'.')}}</swiper-slide>
        <div class="swiper-button-next swiper-btn" slot="button-next"></div>
        <div class="swiper-button-prev swiper-btn" slot="button-prev"></div>
      </swiper>
      <swiper :options="swiperOptionMain" class="gallery-main swiper-nest" ref="swiperOptionMain">
        <swiper-slide v-for="lists in newList" :key="lists.id">
          <div class="items">
            <div class="item-header">
              <div class="title">{{getLang === 'zh' ? lists.title : lists.fantiTitle}}</div>
              <p class="text">{{getLang === 'zh' ? lists.subheading : lists.fantiSubheading}}</p>
            </div>
            <div class="item-body">
              <swiper :options="swiperOptionIn" class="gallery-main-items">
                <swiper-slide v-for="list in lists.newsList" :key="list.id">
                  <div class="insideImg"><img :src="list.url"/></div>
                  <pre class="text" v-html="getLang === 'zh' ? list.picRemark : list.fantiPicRemark"></pre>
                </swiper-slide>
                <div class="swiper-pagination" slot="pagination"></div>
                <div class="swiper-button-prev swiper-btn" slot="button-prev"></div>
                <div class="swiper-button-next swiper-btn" slot="button-next"></div>
              </swiper>
            </div>
          </div>
        </swiper-slide>
      </swiper>
    </div>
  </div>
</template>

<script>
export default {
  name: 'doubleSwiper',
  data () {
    return {
      newList: [],
      defaultList: [
        {
          publishTime: '2018-06-14 00:00:00',
          title: '新福港·筑爱义工队第一站',
          subheading: '新福港地产成立的‘筑爱·义工队’在端午佳节来临之际，于广州荔湾区岭南街道开展对帮扶“浓情端午·筑爱岭南”志愿慰问活动，并且为残障特困家庭准备粽子、风扇、油等生活用品，让残障人士及孤老独居长者过上一个欢乐祥和的端午节。',
          fantiTitle: '新福港·築愛義工隊第一站',
          fantiSubheading: '新福港地產成立的‘築愛·義工隊’在端午佳節來臨之際，於廣州荔灣區嶺南街道開展對幫扶“濃情端午·築愛嶺南”志願慰問活動，並且為殘障特困家庭準備粽子、風扇、油等生活用品，讓殘障人士及孤老獨居長者過上一個歡樂祥和的端午節。',
          newsList: [
            {
              picRemark: `准备好了吗？Let’s  go！`,
              fantiPicRemark: `準備好了嗎？Let’s  go！`,
              url: 'static/images/news/20180614_01.png'
            },
            {
              picRemark: `为送暖行动一起包粽子`,
              fantiPicRemark: `為送暖行動一起包粽`,
              url: 'static/images/news/20180614_02.jpg'
            },
            {
              picRemark: `为送暖行动一起包粽子`,
              fantiPicRemark: `為送暖行動一起包粽`,
              url: 'static/images/news/20180614_03.jpg'
            },
            {
              picRemark: `为送暖行动一起包粽子`,
              fantiPicRemark: `為送暖行動一起包粽`,
              url: 'static/images/news/20180614_04.jpg'
            },
            {
              picRemark: `合照留念`,
              fantiPicRemark: `合照留念`,
              url: 'static/images/news/20180614_05.jpg'
            },
            {
              picRemark: `2018年6月15日星期五<br/>
新福港筑爱义工队连同社工一起深入探访数10户建档立卡贫困老人以及残障人士家中，为他们带去了粽子、电风扇等慰问品，并详细询问了他们的生活近况和面临的困难，鼓励他们要坚定对生活的信心，克服困难。
此次活动不仅让残障人士和长者们感受到节日的关怀，进一步传承了尊老、爱老、敬老、养老的中华民族传统美德，弘扬了“奉献、友爱、互助、进步”的志愿服务精神。`,
              fantiPicRemark: `2018年6月15日星期五<br/>
新福港築愛義工隊連同社工一起深入探訪數10戶建檔立卡貧困老人以及殘障人士家中，為他們帶去了粽子、電風扇等慰問品，並詳細詢問了他們的生活近況和面臨的困難，鼓勵他們要堅定對生活的信心，克服困難。
此次活動不僅讓殘障人士和長者們感受到節日的關懷，進一步傳承了尊老、愛老、敬老、養老的中華民族傳統美德，弘揚了“奉獻、友愛、互助、進步”的志願服務精神。`,
              url: 'static/images/news/20180614_06.jpg'
            },
            {
              picRemark: `义工队与爱心志愿者送温暖中`,
              fantiPicRemark: `義工隊與愛心志願者送溫暖中`,
              url: 'static/images/news/20180614_07.jpg'
            },
            {
              picRemark: `义工队与爱心志愿者送温暖中`,
              fantiPicRemark: `義工隊與愛心志願者送溫暖中`,
              url: 'static/images/news/20180614_08.jpg'
            },
            {
              picRemark: `为期两天的“浓情端午·筑爱岭南”活动在残障者和长者们的笑声中完满拉下帷幕，感谢首批新福港地产· 筑爱义工队志愿者们的付出，希望日后的“筑爱行动”里有更多的同事加入，作为新福港人，为新福港的筑爱行动引以为傲。`,
              fantiPicRemark: `為期兩天的“濃情端午·築愛嶺南”活動在殘障者和長者們的笑聲中完滿拉下帷幕，感謝首批新福港地產· 築愛義工隊志願者們的付出，希望日後的“築愛行動”裡有更多的同事加入，作為新福港人，為新福港的築愛行動引以為傲。`,
              url: 'static/images/news/20180614_09.jpg'
            }
          ]
        },
        {
          publishTime: '2018-06-28 00:00:00',
          title: '新福港地产2018员工运动会-历奇派对',
          subheading: `2018年6月28日，新福港地产的员工带着狂热，顷刻间席卷了整座佛山新DNA购物中心。随着刮起的夏风，扫过这个体内每一个历奇基因，蕴涵着袭人的热量，共同打开首个【新福港地产员工趣味运动会の历奇派对】的“蓝色大门”。`,
          fantiTitle: '新福港地產2018員工運動會-歷奇派對',
          fantiSubheading: `2018年6月28日，新福港地產的員工帶著狂熱，頃刻間席捲了整座佛山新DNA購物中心。隨著颳起的夏風，掃過這個體內每一個歷奇基因，蘊涵著襲人的熱量，共同開啟首個【新福港地產員工趣味運動會の歷奇派對】的“藍色大門”。`,
          newsList: [
            {
              picRemark: `准备好了吗？Let’s  go！`,
              fantiPicRemark: `準備好了嗎？Let’s  go！`,
              url: 'static/images/news/20180628_01.jpg'
            },
            {
              picRemark: `先热身一下，激活热血因子！为一天的历奇打好地基！`,
              fantiPicRemark: `先熱身一下，激活熱血因子！為一天的歷奇打好地基！`,
              url: 'static/images/news/20180628_02.jpg'
            },
            {
              picRemark: `授旗仪式- 各队长从新福港地产总裁邓锦护先生手中接过队旗，正式起航！`,
              fantiPicRemark: `授旗儀式- 各隊長從新福港地産總裁鄧錦護先生手中接過隊旗，正式起航！`,
              url: 'static/images/news/20180628_03.jpg'
            },
            {
              picRemark: `热血队员们即使在麻辣指压板上，依然无所畏惧！那一刻心里面只有团体和胜利啊！`,
              fantiPicRemark: `熱血隊員們即使在麻辣指壓板上，依然無所畏懼！那一刻心裏面只有團體和勝利啊！`,
              url: 'static/images/news/20180628_04.jpg'
            },
            {
              picRemark: `热血队员们即使在麻辣指压板上，依然无所畏惧！那一刻心里面只有团体和胜利啊！`,
              fantiPicRemark: `熱血隊員們即使在麻辣指壓板上，依然無所畏懼！那一刻心裏面只有團體和勝利啊！`,
              url: 'static/images/news/20180628_05.jpg'
            },
            {
              picRemark: `不长不短的距离，需要的是全身、全心、全程地投入，自始至终你们都在拼全力，此时此刻，你们处在最光的高地，无论胜败，只要撑下去,你们就是我们的历奇英雄！`,
              fantiPicRemark: `不長不短的距離，需要的是全身、全心、全程地投入，自始至終你們都在拼全力，此時此刻，你們處在最光的高地，無論勝敗，只要撐下去,你們就是我們的歷奇英雄！`,
              url: 'static/images/news/20180628_06.jpg'
            },
            {
              picRemark: `像一颗~海草~海草~海草~海草~随波飘摇~~
有什么比炎炎夏日中，在航海主题的佛山新福港DNA购物中心里跳着海草舞更让人心旷神怡的呢~`,
              fantiPicRemark: `像一顆~海草~海草~海草~海草~隨波飄搖~~
有什麼比炎炎夏日中，在航海主題的佛山新福港DNA購物中心裡跳著海草舞更讓人心曠神怡的呢~`,
              url: 'static/images/news/20180628_07.jpg'
            },
            {
              picRemark: `组队购买列表商品`,
              fantiPicRemark: `組隊購買列表商品`,
              url: 'static/images/news/20180628_08.jpg'
            },
            {
              picRemark: `集思广益，争分夺秒完成任务`,
              fantiPicRemark: `集思廣益，爭分奪秒完成任務`,
              url: 'static/images/news/20180628_09.jpg'
            },
            {
              picRemark: `啊~这一场头脑风暴啊~`,
              fantiPicRemark: `啊~這一場頭腦風暴啊~`,
              url: 'static/images/news/20180628_10.jpg'
            },
            {
              picRemark: `历尽千帆，奇妙无穷，在赛场上，用眼睛见证了赛场上的是非成败，而是用心灵感受了运动员的喜怒哀乐。
他们自信、坚持、团结，场上每一个点滴，都如此的震撼，也让我见识了历奇的精神！同时，希望下届的新福港运动会上，能够再次见到各位队员为团队奋斗的英姿！`,
              fantiPicRemark: `歷盡千帆，奇妙無窮，在賽場上，用眼睛見證了賽場上的是非成敗，而是用心靈感受了運動員的喜怒哀樂。
他們自信、堅持、團結，場上每一個點滴，都如此的震撼，也讓我見識了歷奇的精神！同時，希望下屆的新福港運動會上，能夠再次見到各位隊員為團隊奮鬥的英姿！`,
              url: 'static/images/news/20180628_11.jpg'
            },
            {
              picRemark: `历尽千帆，奇妙无穷，在赛场上，用眼睛见证了赛场上的是非成败，而是用心灵感受了运动员的喜怒哀乐。
他们自信、坚持、团结，场上每一个点滴，都如此的震撼，也让我见识了历奇的精神！同时，希望下届的新福港运动会上，能够再次见到各位队员为团队奋斗的英姿！`,
              fantiPicRemark: `歷儘千帆，奇妙無窮，在賽場上，用眼睛見証了賽場上的是非成敗，而是用心靈感受了運動員的喜怒哀樂。
他們自信、堅持、團結，場上每一個點滴，都如此的震撼，也讓我見識了歷奇的精神！同時，希望下屆的新福港運動會上，能夠再次見到各位隊員爲團隊奮鬥的英姿！`,
              url: 'static/images/news/20180628_12.jpg'
            },
            {
              picRemark: `历尽千帆，奇妙无穷，在赛场上，用眼睛见证了赛场上的是非成败，而是用心灵感受了运动员的喜怒哀乐。
他们自信、坚持、团结，场上每一个点滴，都如此的震撼，也让我见识了历奇的精神！同时，希望下届的新福港运动会上，能够再次见到各位队员为团队奋斗的英姿！，`,
              fantiPicRemark: `歷儘千帆，奇妙無窮，在賽場上，用眼睛見証了賽場上的是非成敗，而是用心靈感受了運動員的喜怒哀樂。
他們自信、堅持、團結，場上每一個點滴，都如此的震撼，也讓我見識了歷奇的精神！同時，希望下屆的新福港運動會上，能夠再次見到各位隊員爲團隊奮鬥的英姿！`,
              url: 'static/images/news/20180628_12.jpg'
            }
          ]
        },
        {
          publishTime: '2018-08-24 00:00:00',
          title: '新福港·筑爱义工队第二站【开学季】',
          subheading: `随着火辣辣的暑假结束，又迎来九月开学季了！   2018年8月24日新福港筑爱义工团队开展了 “暖阳开学季” 爱心捐赠活动，为智障儿童放送开学礼。`,
          fantiTitle: '新福港·築愛義工隊第二站【開學季】',
          fantiSubheading: `隨著火辣辣的暑假結束，又迎來九月開學季了！   2018年8月24日新福港築愛義工團隊開展了 “暖陽開學季” 愛心捐贈活動，為智障兒童放送開學禮。`,
          newsList: [
            {
              picRemark: `琳琅满目的礼物，筑爱义工们在为小朋友们，准备开学礼包。`,
              fantiPicRemark: `琳琅滿目的禮物，築愛義工們在為小朋友們，準備開學禮包。`,
              url: 'static/images/news/20180824_01.jpg'
            },
            {
              picRemark: `新福港筑爱义工队更特派数名义工远赴位于东莞的广东省少年儿童救助保护中心，
`,
              fantiPicRemark: `新福港築愛義工隊更特派數名義工遠赴位於東莞的廣東省少年兒童救助保護中心
`,
              url: 'static/images/news/20180824_02.jpg'
            },
            {
              picRemark: `亲手把礼物交到小朋友手上！本次的捐赠对象为：广东省少年儿童救助保护中心【为保护未成年儿童，图片经过特殊处理。】`,
              fantiPicRemark: `親手把禮物交到小朋友手上！本次的捐贈對象為：廣東省少年兒童救助保護中心【為保護未成年兒童，圖片經過特殊處理。】`,
              url: 'static/images/news/20180824_03.jpg'
            },
            {
              picRemark: `随着他们欢乐笑声和暖暖夕阳的到来..<br/>新福港筑爱义工队第二站，“开学季”爱心捐赠活动也缓缓落下帷幕。<br/>期待我们的下一站爱心活动，继续为爱建筑，用爱建筑！<br/>我们也祝福救护中心的所有小朋友，早日与家人团聚，快乐成长！`,
              fantiPicRemark: `隨著他們歡樂笑聲和暖暖夕陽的到來..<br/>新福港築愛義工隊第二站，“開學季”愛心捐贈活動也緩緩落下帷幕。<br/>期待我們的下一站愛心活動，繼續為愛建築，用愛建築！<br/>我們也祝福救護中心的所有小朋友，早日與家人團聚，快樂成長！`,
              url: 'static/images/news/20180824_04.jpg'
            }
          ]
        },
        {
          publishTime: '2018-09-21 00:00:00',
          title: '2018·爱在“新”秋同乐会',
          subheading: `2018·爱在“新”秋同乐会`,
          fantiTitle: '2018·愛在“新”秋同樂會',
          fantiSubheading: `2018·愛在“新”秋同樂會`,
          newsList: [
            {
              picRemark: `中秋佳节，必需有的欢乐项目绝对就是——猜灯谜！`,
              fantiPicRemark: `中秋佳節，必需有的歡樂項目絕對就是——猜燈謎！`,
              url: 'static/images/news/20180921_01.jpg'
            },
            {
              picRemark: `各地美食，不同口味满足不同同事的口味。`,
              fantiPicRemark: `各地美食，不同口味滿足不同同事的口味。`,
              url: 'static/images/news/20180921_02.jpg'
            },
            {
              picRemark: `在欢笑中结束，最后祝福大家人月两团圆 ，中秋佳节快乐。`,
              fantiPicRemark: `在歡笑中結束，最後祝福大家人月兩團圓 ，中秋佳節快樂。`,
              url: 'static/images/news/20180921_03.jpg'
            }
          ]
        }
      ],
      swiperOptionIn: {
        autoHeight: true,
        autoplay: {
          delay: 5000,
          stopOnLastSlide: false,
          disableOnInteraction: false
        },
        loop: false,
        mousewheel: true,
        pagination: {
          el: '.swiper-pagination',
          type: 'fraction'
        },
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev'
        }
      },
      swiperOptionMain: {
        effect: 'fade'
      },
      swiperOptionThumbs: {
        autoplay: {
          delay: 12000,
          stopOnLastSlide: false,
          disableOnInteraction: false
        },
        centeredSlides: true,
        slidesPerView: 6,
        touchRatio: 0.2,
        slideToClickedSlide: true,
        mousewheel: true,
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev'
        },
        breakpoints: {
          1920: {
            slidesPerView: 6
          },
          1440: {
            slidesPerView: 4
          },
          1024: {
            slidesPerView: 3
          },
          768: {
            slidesPerView: 2
          }
        }
      }
    }
  },
  mounted () {
    this.$nextTick(() => {
      const swiperOptionMain = this.$refs.swiperOptionMain.swiper
      const swiperThumbs = this.$refs.swiperThumbs.swiper
      swiperOptionMain.controller.control = swiperThumbs
      swiperThumbs.controller.control = swiperOptionMain
    })
  },
  computed: {
    getLang () {
      return this.$store.state.lang
    }
  },
  created () {
    // this.$axios.get('http://localhost:8088/api/xinfugang/news/list2')
    this.$axios.get('https://www.sfkp.cn/api/xinfugang/news/list')
    // this.$axios.get('http://223.4.157.105:8081/api/xinfugang/news/list')
      .then(res => {
        // 连接成功后对数据长度<=0的情况下
        if (res.data.data.length <= 0) {
          this.$message({
            message: '获取新闻数量为0，请检查后台是否正确上传新闻动态内容！',
            type: 'warning'
          })
          this.newList = this.defaultList
          return false
        }
        // 连接成功后对数据长度>0的情况下
        this.newList = res.data.data
      })
      .catch(error => {
        this.newList = this.defaultList
        this.$message({
          message: '网络连接失败，请检查网络状况，或稍后再试！',
          type: 'warning'
        })
        console.log(error)
        // alert('加载远程资源失败,请检查网络或稍后再试~')
      })
  },
  methods: {
    on_top_enter () {
      this.mySwiper.autoplay.stop()
      // this.swiperIn.autoplay.stop()
    },
    on_top_leave () {
      this.mySwiper.autoplay.start()
      // this.swiperIn.autoplay.start()
    }
  }
}
</script>

<style scoped lang="stylus">
  @import "~styles/varibles"
  @import "~styles/mixins"
  .wrapper
    width 78%
    font-size 15px
    line-height 26px
    .breadcrumb:before
      afterTop()
      width 4px
      height 60%
      top 20%
      background $navBgColor2
    .breadcrumb:after
      afterBottom()
      borderBottom()
      width 100%
      opacity 0.2
    .breadcrumb
      cn()
      font-size 24px
      font-weight bold
      padding 5px 0 5px 20px
      position relative
      margin-bottom 45px
  .gallery-thumbs:after
    position absolute
    bottom 2px
    left 0
    content ''
    width 100%
    height 1px
    background #ccc
  .gallery-thumbs
    height 60px!important
    box-sizing border-box
    position relative
    .swiper-slide
      text-align center
      display flex
      justify-content center
      align-items center
      opacity 0.4
      font-size 20px
      line-height 45px
      font-family "Source Han Sans CN Normal", Arial, "Helvetica Neue", Helvetica, sans-serif
    .swiper-slide-active
      opacity 1
      box-sizing border-box
      font-size 32px
      line-height 38px
      font-weight bold
      color #000
      border-bottom 5px solid #b0d600
    .swiper-btn
      top 65%!important
      width 50px!important
      height 35px!important
      background-repeat no-repeat
      background-size auto!important
      background-color #fff
    .swiper-button-prev
      left 0
      background-image url("~assets/home/arrow-left.png")!important
      background-position center left
    .swiper-button-next
      right 0
      background-image url("~assets/home/arrow-right.png")!important
      background-position center right
  .gallery-main
    width: 100%
    margin-top 27px
    .items
      background #FFFFFF
      .item-header
        box-sizing border-box
        padding-right 40px
      .title
        cn()
        font-weight bold
        font-size 20px
      .item-body
        margin-top 25px
      .item-footer
        margin-top 25px
        box-sizing border-box
        padding 0 20px
  .gallery-main-items:hover
    .swiper-btn,.swiper-pagination
      opacity 1
  .gallery-main-items
    .swiper-pagination
      opacity 0
      transition opacity 1s
      top 35px!important
    .swiper-btn
      background rgba(0,0,0,0.3)
      background-repeat no-repeat
      background-size cover
      border-radius 3px
      padding 4px 4px
      opacity 0
      transition opacity 1s
      top 50px
    .swiper-button-prev
      background-image url("~~assets/common/width-64-left.png")
      background-position center left
    .swiper-button-next
      background-image url("~~assets/common/width-64-right.png")
      background-position center right
    .text
      margin-top 15px
      background #FFF
</style>



// WEBPACK FOOTER //
// src/pages/news/components/doubleSwiper.vue